import React from "react";
import style from "css/workspace.module.css";
import Questions from "components/app/questions";
import { useMediaQuery } from "react-responsive";
import SEOMeta from "components/app/SEOMeta";
import Consult from "components/device/neat/consult";

function Platform(props) {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  return (
    <>
      <SEOMeta
        title="스마트 워크 플랫폼 all Place, 리브테크놀로지"
        description="리브테크놀로지 riv Technology - 스마트 워크 플랫폼 all Place"
        keywords="리브테크놀로지, 리브테크, 리브, riv, riv Technology, neat, 스마트 회의실, 화상회의, 스마트 워크 플랫폼, all Place"
      />
      <div className={style.wrapper}>
        <div className={style.commonHeader}>
          <div className={style.platformHeaderTxt}>
            <p>
              <font>포스트 코로나의 시대</font>
              <font>새로운 오피스의 기준</font>
            </p>
            <img
              alt=""
              src={`${process.env.REACT_APP_CLIENT_URL}img/common/allplace_logo_wh.png`}
            />
            <p>
              {!isMobile && !isTablet ? (
                <>
                  <font>
                    효율성은 높이면서 유지관리 비용은 절감하는 혁신적 업무
                    환경을 위한
                  </font>
                  <font>
                    리브 테크놀로지의 Hybrid Working System Platform, all
                    Place를 소개합니다.
                  </font>
                </>
              ) : (
                <>
                  <font>
                    효율성은 높이면서 유지관리 비용은{"\n"} 절감하는 혁신적 업무
                    환경을 위한 리브 테크놀로지의{"\n"} Hybrid Working System
                    Platform,{"\n"} all Place를 소개합니다.
                  </font>
                </>
              )}
            </p>
          </div>
          {!isMobile && !isTablet ? (
            <img
              className={style.platformHeaderImg}
              alt=""
              src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/platformHeader.png`}
            />
          ) : (
            <div className={style.platformHeaderImgWrap}>
              <img
                className={style.platformHeaderImg}
                alt=""
                src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/platformHeader_1_m.png`}
              />
              <img
                className={style.platformHeaderImg}
                alt=""
                src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/platformHeader_2_m.png`}
              />
            </div>
          )}

          <div className={style.platformHeader2}>
            <p>
              변화하는 시대에 맞춘{"\n"} 하이브리드 워킹시스템 플랫폼을 이용해
              보세요!
            </p>
            <p>자율좌석제 · 회의실 예약{"\n"} · 화상회의 시스템</p>
            <div className={style.platformHeader2CardWrap}>
              <div>
                <img
                  alt=""
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/platformCardImg.png"
                  }
                />
                <font>
                  온 · 오프라인을 넘나들며,
                  <br /> <label>언제 어디서든</label> 근무 가능
                </font>
              </div>
              <div>
                <img
                  alt=""
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/platformCardImg2.png"
                  }
                />
                <font>
                  최적화된 사무공간으로
                  <br /> <label>임대비용 절감</label>
                </font>
              </div>
              <div>
                <img
                  alt=""
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/platformCardImg3.png"
                  }
                />
                <font>
                  공간의 혁신을 통한
                  <br /> <label>유연하고 창의적인 팀원과의 협업</label>
                </font>
              </div>
            </div>
          </div>
          <div className={style.platformHeader3}>
            <div className={style.txt}>
              <font>(주)리브테크놀로지를</font>
              <font>선택해야 하는 이유!</font>
            </div>
            <div className={style.cardWrap}>
              {!isMobile && !isTablet ? (
                <>
                  <div className={style.cardList}>
                    <div className={style.card2}>
                      <div className={style.card1Num}>01</div>
                      <div className={style.card2Txt}>
                        <font>화상회의 예약은 물론</font>
                        <font>일반회의 및 회의실 예약까지!</font>
                      </div>
                    </div>
                    <div className={style.card2}>
                      <div className={style.card1Num}>02</div>
                      <div className={style.card2Txt}>
                        <font>좌석예약 및 체크인, 체크아웃이 간편한</font>
                        <font>자율좌석제(Hot Desking) 서비스</font>
                      </div>
                    </div>
                  </div>
                  <div className={style.cardList}>
                    <div className={style.card2}>
                      <div className={style.card1Num}>03</div>
                      <div className={style.card2Txt}>
                        <font>화상회의 질을 높여줄 최첨단</font>
                        <font>화상회의 장비(neat.)와 일정 연동</font>
                      </div>
                    </div>{" "}
                    <div className={style.card2}>
                      <div className={style.card1Num}>04</div>
                      <div className={style.card2Txt}>
                        <font>회의관련 데이터를 한눈에 볼 수 있는</font>
                        <font>대시보드·통계 등 편의 기능 탑재</font>
                      </div>
                    </div>
                  </div>
                  <div className={style.card1}>
                    <div className={style.card1Line}>
                      <font className={style.card1Num}>05</font>
                      <div className={style.card1Txt}>
                        <font>화상회의 시스템</font>
                        <font>
                          다양한 전문 화상회의 플랫폼부터 일정 관리까지!
                        </font>
                      </div>
                    </div>
                    <div className={style.card1Line}>
                      <font className={style.card1Num2}>01</font>
                      <div className={style.cardImgList}>
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/platformComp1.png"
                          }
                        />
                        <div />
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/platformComp2.png"
                          }
                        />
                        <div />
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/platformComp3.png"
                          }
                        />
                        <div />
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/platformComp4.png"
                          }
                        />
                        <div />
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/platformComp5.png"
                          }
                        />
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className={style.card1}>
                    <div className={style.card1Line}>
                      <font className={style.card1Num}>01</font>
                      <div className={style.card1Txt}>
                        <font>화상회의 시스템</font>
                        <font>
                          다양한 전문 화상회의 플랫폼부터 일정 관리까지!
                        </font>
                      </div>
                    </div>
                    <div className={style.card1Line}>
                      {/* <font className={style.card1Num2}>01</font> */}
                      <div className={style.cardImgList}>
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/platformComp1.png"
                          }
                        />
                        <div />
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/platformComp2.png"
                          }
                        />
                        <div />
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/platformComp3.png"
                          }
                        />
                      </div>
                      <div className={style.cardImgList}>
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/platformComp4.png"
                          }
                        />
                        <div />
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/platformComp5.png"
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className={style.card2}>
                    <div className={style.card1Num}>02</div>
                    <div className={style.card2Txt}>
                      <font>화상회의 예약은물론</font>
                      <font>일반회의 및 회의실 예약까지!</font>
                    </div>
                  </div>
                  <div className={style.card2}>
                    <div className={style.card1Num}>03</div>
                    <div className={style.card2Txt}>
                      <font>좌석예약및 체크인, 체크아웃이 간편한</font>
                      <font>자율좌석제(Hot Desking) 서비스</font>
                    </div>
                  </div>
                  <div className={style.card2}>
                    <div className={style.card1Num}>04</div>
                    <div className={style.card2Txt}>
                      <font>화상회의 질을 높여줄 최첨단</font>
                      <font>화상회의 장비(neat.)와 일정 연동</font>
                    </div>
                  </div>
                  <div className={style.card2}>
                    <div className={style.card1Num}>05</div>
                    <div className={style.card2Txt}>
                      <font>회의관련 데이터를 한눈에 볼 수 있는</font>
                      <font>대시보드·통계 등 편의 기능 탑재</font>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        <div className={style.platformHeader4}>
          <font>{"국내 유일\nAll-in-One 플랫폼"}</font>
          <font>
            all Place는 회의실 예약 및 영상회의,{"\n"} 자율좌석제 지정까지
            <br />
            포스트 코로나 시대의 업무환경을{"\n"} 관리해주고 참여할 수 있는
            사이트 입니다.
          </font>
          {!isTablet && !isMobile ? (
            <div className={style.imgBorderWrap}>
              <img
                alt=""
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  "img/smartspace/platformSolution.png"
                }
              />
            </div>
          ) : (
            <img
              alt=""
              src={
                `${process.env.REACT_APP_CLIENT_URL}` +
                "img/smartspace/platformSolution_m.png"
              }
            />
          )}
        </div>

        <div className={style.platformInfo}>
          <div className={style.InfoHeader}>
            <font>효율적인 관리와{"\n"} 직관적인 사용성</font>
            <font>
              메인페이지에서 전체 현황을 한눈에 파악하고,
              <br />
              마이페이지와 캘린더로 개인 스케줄과 예약을{"\n"} 손쉽게 관리할 수
              있습니다.
            </font>
          </div>

          <div className={style.platformWrap}>
            <div className={style.infoTxt}>
              <div className={style.infoTxtImg}>
                <img
                  alt=""
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/infotxt1.png"
                  }
                />
              </div>
              <p className={style.infoTxtTitle}>
                <font>Main Page</font> <span /> <font>메인 페이지</font>
              </p>
              <p className={style.infoTxtBody}>
                {!isMobile && !isTablet ? (
                  <font>
                    <label>
                      Hot Desking 예약부터 회의실 일정 확인까지,
                      <br />
                      한눈에 보는 스마트 예약 현황.
                    </label>
                    <br />
                    예약된 좌석과 회의실 정보를 달력과 타임라인으로 쉽게 확인할
                    수 있으며,
                    <br /> 부서별 좌석 현황도 실시간으로 확인 가능합니다.
                    <br /> 직관적인 인터페이스로 효율적인 공간 관리를
                    지원합니다.
                  </font>
                ) : (
                  <font>
                    <label>
                      Hot Desking 예약부터 회의실 일정 확인까지,
                      <br />
                      한눈에 보는 스마트 예약 현황.
                    </label>
                    <br />
                    예약된 좌석과 회의실 정보를 달력과 타임라인으로 쉽게 확인할
                    수 있으며, 부서별 좌석 현황도 실시간으로 확인 가능합니다.
                    직관적인 인터페이스로 효율적인 공간 관리를 지원합니다.
                  </font>
                )}
              </p>
            </div>
            <div className={style.infoImg}>
              <img
                alt=""
                src={
                  !isMobile && !isTablet
                    ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg1.png`
                    : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg1_m.png`
                }
              />
            </div>
          </div>

          {!isMobile && !isTablet ? (
            <div className={style.platformWrap}>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg2.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg2_m.png`
                  }
                />
              </div>
              <div className={style.infoTxt2}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/infotxt2.png"
                    }
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>
                    Hot Desking
                    <br />
                    Reservation & Status
                  </font>{" "}
                  <font>자율좌석 예약 및 현황</font>
                </p>
                <p className={style.infoTxtBody}>
                  <font>
                    사용자의 예약 이력을 바탕으로
                    <label> 추천 좌석을 제공</label>
                    하며,
                    <br />
                    확정된 좌석과 다양한 기능을 통해 업무 효율성을 극대화할 수
                    있습니다.
                    <br />
                    <label>손쉬운 좌석 선택과 체계적인 예약 관리</label>를 통해
                    더 유연하고 스마트한
                    <br />
                    업무 환경을 경험해 보세요.
                  </font>
                </p>
              </div>
            </div>
          ) : (
            <div className={style.platformWrap}>
              <div className={style.infoTxt2}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/infotxt2.png"
                    }
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>
                    Hot Desking
                    <br />
                    Reservation & Status
                  </font>{" "}
                  <font>자율좌석 예약 및 현황</font>
                </p>
                <p className={style.infoTxtBody}>
                  {!isMobile && !isTablet ? (
                    <font>
                      사용자의 예약 이력을 바탕으로
                      <label> 추천 좌석을 제공</label>
                      하며,
                      <br />
                      확정된 좌석과 다양한 기능을 통해 업무 효율성을 극대화할 수
                      있습니다.
                      <br />
                      <label>손쉬운 좌석 선택과 체계적인 예약 관리</label>를
                      통해 더 유연하고 스마트한
                      <br />
                      업무 환경을 경험해 보세요.
                    </font>
                  ) : (
                    <font>
                      사용자의 예약 이력을 바탕으로
                      <label> 추천 좌석을 제공</label>
                      하며, 확정된 좌석과 다양한 기능을 통해 업무 효율성을
                      극대화할 수 있습니다.
                      <br />
                      <label>손쉬운 좌석 선택과 체계적인 예약 관리</label>를
                      통해 더 유연하고 스마트한 업무 환경을 경험해 보세요.
                    </font>
                  )}
                </p>
              </div>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg2.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg2_m.png`
                  }
                />
              </div>
            </div>
          )}

          <div className={style.platformWrap}>
            <div className={style.infoTxt}>
              <div className={style.infoTxtImg}>
                <img
                  alt=""
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/infotxt3.png"
                  }
                />
              </div>
              <p className={style.infoTxtTitle}>
                <font>조감도</font>
                {/* <font>자율좌석 동료현황</font> */}
              </p>
              <p className={style.infoTxtBody}>
                {!isMobile && !isTablet ? (
                  <font>
                    <label>건물별,층별 사무실 조감도를 제공</label>하여
                    <br />
                    좌석및 회의실의 <label>위치를 확인하고</label>
                    <br />
                    직관적으로 <label>쉽게 예약</label>할 수 있습니다.
                    <br />
                    <br />
                    <br />※ Web, Mobile, Kiosk 버전을 모두 제공합니다.
                  </font>
                ) : (
                  <font>
                    <label>건물별,층별 사무실 조감도를 제공</label>하여 좌석및
                    회의실의 <label>위치를 확인하고</label>
                    직관적으로 <label>쉽게 예약</label>할 수 있습니다.
                    <br /> <br />※ Web, Mobile, Kiosk 버전을 모두 제공합니다.
                  </font>
                )}
              </p>
            </div>
            <div className={style.infoImg}>
              <img
                alt=""
                src={
                  !isMobile && !isTablet
                    ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg3.png`
                    : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg3_m.png`
                }
              />
            </div>
          </div>

          {!isMobile && !isTablet ? (
            <div className={style.platformWrap}>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg4.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg4_m.png`
                  }
                />
              </div>
              <div className={style.infoTxt2}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/infotxt4.png"
                    }
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>Hot Desking Colleague Status</font>
                  <font>자율좌석 동료현황</font>
                </p>
                <p className={style.infoTxtBody}>
                  <font>
                    <label>나의 좌석 정보</label>를 손쉽게 공유하고,{" "}
                    <label>동료의 현재 접속 여부</label> 및<br />
                    <label>근무 상태</label>
                    를 한눈에 확인할 수 있습니다.
                    <br />
                    팀원 간 빠른 위치 파악과 소통을 통해 협업 효율을 높여보세요.
                  </font>
                </p>
              </div>
            </div>
          ) : (
            <div className={style.platformWrap}>
              <div className={style.infoTxt2}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/infotxt4.png"
                    }
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>Hot Desking Colleague Status</font>
                  <font>자율좌석 동료현황</font>
                </p>
                <p className={style.infoTxtBody}>
                  <font>
                    <label>나의 좌석 정보</label>를 손쉽게 공유하고,{" "}
                    <label>
                      동료의 현재 접속
                      <br />
                      여부
                    </label>{" "}
                    및 <label>근무 상태</label>를 한눈에 확인할 수 있습니다.
                    <br />
                    팀원 간 빠른 위치 파악과 소통을 통해 협업 효율을 높여보세요.
                  </font>
                </p>
              </div>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg4.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg4_m.png`
                  }
                />
              </div>
            </div>
          )}

          {!isMobile && !isTablet ? (
            <div className={style.platformWrap}>
              <div className={style.infoTxt2}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/infotxt5.png"
                    }
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>Meeting Room Overview</font> <font>회의실 현황</font>
                </p>
                <p className={style.infoTxtBody}>
                  <font>
                    모든 회의실 현황을 한눈에 확인할 수 있습니다.
                    <br />
                    일반회의실과 화상회의실 현황을 확인하여 원하는 회의를 쉽고
                    편리하게
                    <br />
                    예약할 수 있습니다.
                  </font>
                </p>
              </div>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg5.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg5_m.png`
                  }
                />
              </div>
            </div>
          ) : (
            <div className={style.platformWrap}>
              <div className={style.infoTxt2}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/infotxt5.png"
                    }
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>Meeting Room Overview</font> <font>회의실 현황</font>
                </p>
                <p className={style.infoTxtBody}>
                  <font>
                    모든 회의실 현황을 한눈에 확인할 수 있습니다.
                    <br />
                    일반회의실과 화상회의실 현황을 확인하여 원하는 회의를 쉽고
                    편리하게 예약할 수 있습니다.
                  </font>
                </p>
              </div>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg5.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg5_m.png`
                  }
                />
              </div>
            </div>
          )}

          {!isMobile && !isTablet ? (
            <div className={style.platformWrap}>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg6.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg6_m.png`
                  }
                />
              </div>
              <div className={style.infoTxt2}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/infotxt6.png"
                    }
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>Calendar</font>
                  <font>회의예약 스케줄링 캘린더</font>
                </p>
                <p className={style.infoTxtBody}>
                  <font>
                    하나의 캘린더로 일정 / 회의실 및 단말예약이 모두 가능합니다.
                    <br />
                    Drag & Drop 으로 손쉽게 예약 및 관리를 할 수 있으며,
                    <br />
                    사용자가 편리하게 이용할 수 있도록 주간 / 월간 캘린더형식을
                    제공합니다.
                  </font>
                </p>
              </div>
            </div>
          ) : (
            <div className={style.platformWrap}>
              <div className={style.infoTxt2}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/infotxt6.png"
                    }
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>Calendar</font>
                  <font>회의예약 스케줄링 캘린더</font>
                </p>
                <p className={style.infoTxtBody}>
                  <font>
                    하나의 캘린더로 일정 / 회의실 및 단말예약이 모두 가능합니다.
                    <br />
                    Drag & Drop 으로 손쉽게 예약 및 관리를 할 수 있으며,
                    <br />
                    사용자가 편리하게 이용할 수 있도록 주간 / 월간 캘린더형식을
                    제공합니다.
                  </font>
                </p>
              </div>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg6.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg6_m.png`
                  }
                />
              </div>
            </div>
          )}

          <div className={style.platformWrap}>
            <div className={style.infoTxt}>
              <div className={style.infoTxtImg}>
                <img
                  alt=""
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/infotxt7.png"
                  }
                />
              </div>
              <p className={style.infoTxtTitle}>
                <font>Multi-Platform</font> <font>멀티플랫폼 지원</font>
              </p>
              <p className={style.infoTxtBody}>
                {!isMobile && !isTablet ? (
                  <font>
                    예약화면에서 멀티플랫폼 모두를 자유롭게 사용하실 수 있어
                    <br />
                    다양하고 유연하게 화상회의를 개설하고 참여할 수 있습니다.
                  </font>
                ) : (
                  <font>
                    예약화면에서 멀티플랫폼 모두를 자유롭게 사용하실 수 있어
                    다양하고 유연하게 화상회의를 개설하고 참여할 수 있습니다.
                  </font>
                )}
              </p>
            </div>
            <div className={style.infoImg}>
              <img
                alt=""
                src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg7_m.png`}
              />
            </div>
          </div>

          {!isMobile && !isTablet ? (
            <div className={style.platformWrap}>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg8.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg8_m.png`
                  }
                />
              </div>
              <div className={style.infoTxt2}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/infotxt8.png`}
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>Dashboard</font>
                  <font>대시보드 제공</font>
                </p>
                <p className={style.infoTxtBody}>
                  <font>
                    다양한 형태의 대시보드를 제공합니다.
                    <br />
                    출장비 (Off-line) 절감 금액에 대한 데이터도 제공 받을 수
                    있습니다.
                  </font>
                </p>
              </div>
            </div>
          ) : (
            <div className={style.platformWrap}>
              <div className={style.infoTxt2}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/infotxt8.png`}
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>Dashboard</font>
                  <font>대시보드 제공</font>
                </p>
                <p className={style.infoTxtBody}>
                  <font>
                    다양한 형태의 대시보드를 제공합니다.
                    <br />
                    출장비 (Off-line) 절감 금액에 대한 데이터도 제공 받을 수
                    있습니다.
                  </font>
                </p>
              </div>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg8.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg8_m.png`
                  }
                />
              </div>
            </div>
          )}

          <div className={style.introduction_method_area}>
            <div className={style.introduction_method_title}>
              all Place는 도입 방식에따라 {"\n"}
              <span>구축형 or 구독형</span> 중{" "}
              {!isMobile && !isTablet ? null : "\n"}선택하실 수 있습니다.
            </div>
            <div className={style.introduction_method_contents}>
              <div className={style.introduction_method_box}>
                <div className={style.introduction_method_item_title}>
                  <span>구축형</span>
                  <br />
                  (On-premise)
                </div>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/on_premise.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/on_premise_m.png`
                  }
                />
                <div className={style.introduction_method_item_feature}>
                  기업 전용환경에 맞춘 맞춤형 설치
                </div>
                <div className={style.introduction_method_item_description}>
                  <div
                    className={style.introduction_method_item_description_item}
                  >
                    <span />
                    사내 전산망 또는 폐쇄망에서도 사용 가능
                  </div>
                  <div
                    className={style.introduction_method_item_description_item}
                  >
                    <span />
                    초기 구축 후, 자사 인프라 기반으로 운용
                  </div>
                </div>
              </div>
              <div className={style.introduction_method_box}>
                <div className={style.introduction_method_item_title}>
                  <span>구독형</span>
                  <br />
                  (SaaS)
                </div>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/saas.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/saas_m.png`
                  }
                />
                <div className={style.introduction_method_item_feature}>
                  클라우드 기반으로 간편하게 사용하는
                  {!isMobile && !isTablet ? null : <br />}서비스형 모델
                </div>
                <div className={style.introduction_method_item_description}>
                  <div
                    className={style.introduction_method_item_description_item}
                  >
                    <span />
                    별도 서버 없이 빠르게 시작 가능
                  </div>
                  <div
                    className={style.introduction_method_item_description_item}
                  >
                    <span />
                    연간 구독 방식으로 예산 관리 용이
                  </div>
                </div>
              </div>
            </div>

            <div className={style.introduction_method_footer}>
              <div className={style.introduction_method_text}>
                간단한 상담만으로도{"\n"}
                <span>방향</span>이 보일 수 있습니다.
              </div>
              <div className={style.contact_list}>
                <div className={style.contact_item}>
                  <div className={style.contact_item_icon_wrap}>
                    <img
                      alt=""
                      src={
                        !isMobile && !isTablet
                          ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/tel.png`
                          : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/tel_m.png`
                      }
                    />
                  </div>
                  <div className={style.contact_item_text}>070-7798-1311</div>
                </div>
                {!isMobile && !isTablet ? <span /> : null}
                <div className={style.contact_item}>
                  <div className={style.contact_item_icon_wrap}>
                    <img
                      alt=""
                      src={
                        !isMobile && !isTablet
                          ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/mail.png`
                          : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/mail_m.png`
                      }
                    />
                  </div>
                  <div className={style.contact_item_text}>
                    support@riv-tech.co.kr
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className={style.platformFooter}
            style={{
              backgroundImage:
                !isMobile && !isTablet
                  ? "url('" +
                    process.env.REACT_APP_CLIENT_URL +
                    "img/smartspace/platform_bg.png')"
                  : "url('" +
                    process.env.REACT_APP_CLIENT_URL +
                    "img/smartspace/platform_bg_m.png')",
            }}
          >
            <p>
              <span>“</span>
              국내는 물론 세계 최다 {"\n"}레퍼런스 솔루션 보유
            </p>
            <p>
              수년간의 노하우와 탄탄한 포트폴리오. <br /> 리브테크놀로지에서
              {"\n"}
              Hybrid Working System 구축하세요.
            </p>
          </div>
        </div>

        {props.type === "popup" ? (
          <div style={{ marginBottom: "70px", width: "100%" }}>
            <Consult page="allPlace" />
          </div>
        ) : (
          <div className={style.device_consult_wrapper}>
            <Questions />
          </div>
        )}
      </div>
    </>
  );
}

export default Platform;
